import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function MinusIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg width={width || 15} height={height || 2} viewBox="0 0 15 2" {...props}>
      <rect
        data-name="Rectangle 1777"
        width={width || 15}
        height={height || 2}
        rx={1}
        transform="translate(-48 -454.288) translate(48 454.288)"
        fill={color || "#818a91"}
      />
    </svg>
  );
}
